<template>
  <div class="d-flex align-items-center border border-dark rounded py-2" @mouseover.self="onHover" @mouseleave.self="onBlur">
    <draggable
      v-if="nodes.length"
      class="d-flex align-items-center"
      style="gap: 5px"
      :list="nodes"
      animation="150"
      handle=".handler"
    >
      <div v-for="(node, index) of nodes" :key="index">
        <div v-if="'children' in node">
          <GroupNodes
            :depth="depth + 1"
            :nodes="node.children"
            :id="node.id"
            :settings="settings"
            @node-add="onNodeAdd"
            @group-add="onGroupAdd"
            @node-remove="onNodeRemove"
            @group-remove="onGroupRemove"
          />
        </div>
        <div v-else class="d-flex">
          <Node
            :node="node"
            class="handler"
            @node-remove="onNodeRemove({ nodes, id: node.id })"
          />
        </div>
      </div>
    </draggable>
    <div class="d-flex align-items-center">
      <NodeAddButton
        :id="id"
        :nodes="nodes"
        :settings="settings"
        @node-add="onNodeAdd"
        @group-add="onGroupAdd"
      />
      <NodeRemoveButton
        v-if="depth !== 0"
        :nodes="nodes"
        :id="id"
        @group-remove="onGroupRemove"
      />
    </div>
  </div>
</template>

<script>
// Components
import Node from '@/components/lmQueryBuilder/components/Node.vue'
import NodeAddButton from '@/components/lmQueryBuilder/components/NodeAddButton.vue'
import NodeRemoveButton from '@/components/lmQueryBuilder/components/NodeRemoveButton.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

// Utils
import draggable from 'vuedraggable'

export default {
  name: 'GroupNodes',
  components: {
    Node,
    NodeAddButton,
    NodeRemoveButton,
    LmButton,
    LmTreeSelect,
    draggable
  },
  props: {
    nodes: Array,
    settings: Array,
    depth: {
      type: Number,
      default: 0
    },
    id: [Number, String]
  },
  data () {
    return {
      nodeToAdd: null
    }
  },
  methods: {
    onNodeAdd (nodes) {
      this.$emit('node-add', nodes)
    },
    onNodeRemove (nodes) {
      this.$emit('node-remove', nodes)
    },
    onGroupAdd (nodes) {
      this.$emit('group-add', nodes)
    },
    onGroupRemove (nodes) {
      this.$emit('group-remove', nodes)
    },
    onHover (event) {
      event.target.classList.remove('border-dark')
      event.target.classList.add('border-primary')
    },
    onBlur (event) {
      event.target.classList.remove('border-primary')
      event.target.classList.add('border-dark')
    }
  }
}
</script>
